import cookieParser from 'cookie';
import Cookie from 'js-cookie';
import type { NextPageContext } from 'next';
import { appendSetCookie } from './appendSetCookie';

const MINIMAL_STYLE = 'minimal';
export const MINIMAL_STYLE_COOKIE = 'minimalStyle';

const STYLE_PARAM = 'style';
const COOKIE_SET = '1';

const cookieOptions = () => {
  const isProduction = process.env.NODE_ENV === 'production';

  return {
    path: '/',
    secure: isProduction,
    sameSite: isProduction ? ('none' as const) : ('lax' as const),
    partitioned: isProduction,
  };
};

let rememberedOnClient = false;

export const rememberMinimalStyle = (isMinimalStyle: boolean) => {
  rememberedOnClient = isMinimalStyle;
};

export const resolveMinimalStyle = (ctx: NextPageContext): boolean => {
  const style = ctx.query?.[STYLE_PARAM];
  const hasStyle = style !== undefined;
  const isMinimalStyle = style === MINIMAL_STYLE;

  if (ctx.req && ctx.res) {
    if (!hasStyle) {
      const cookies = cookieParser.parse(ctx.req.headers.cookie ?? '');
      return cookies[MINIMAL_STYLE_COOKIE] === COOKIE_SET;
    }

    appendSetCookie(
      ctx.res,
      isMinimalStyle
        ? cookieParser.serialize(MINIMAL_STYLE_COOKIE, COOKIE_SET, cookieOptions())
        : cookieParser.serialize(MINIMAL_STYLE_COOKIE, '', { ...cookieOptions(), maxAge: 0 })
    );

    return isMinimalStyle;
  }

  if (!hasStyle) {
    return rememberedOnClient || Cookie.get(MINIMAL_STYLE_COOKIE) === COOKIE_SET;
  }

  if (isMinimalStyle) {
    Cookie.set(MINIMAL_STYLE_COOKIE, COOKIE_SET, cookieOptions());
  } else {
    Cookie.remove(MINIMAL_STYLE_COOKIE, cookieOptions());
  }

  return isMinimalStyle;
};
